import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import passwordApi from "../../services/passwordPolicyApi";
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';

export const getPasswordPolicy = createAsyncThunk("password/getPasswordPolicy", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await passwordApi.getPasswordPolicy(data);
        if (response.status === 0) {      
            dispatch(setPasswordPolicyFetched())     
            return response?.data?.passwordPolicy;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

const passwordPolicySlice= createSlice({
    name: "password",
    initialState: {
        passwordPolicy: null,
        passwordPolicyLoading: false,
        isPasswordPolicyFetched: false,
        error: null,
    },
    reducers: {
        setPasswordPolicyFetched: (state, action) => {
            state.isPasswordPolicyFetched = true;
        }
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, getPasswordPolicy, "passwordPolicy", "error", "passwordPolicyLoading");
    },
});
export const { setPasswordPolicyFetched } = passwordPolicySlice.actions;
export default passwordPolicySlice.reducer;